import React from "react";
import { Link } from "@sscs/ui";
import { LOGIN_ROUTE } from "Constants";
import styles from "./backToLogin.module.scss";

const BackToLogin = () => {
  return (
    <span className={styles.root}>
      <Link to={`/${LOGIN_ROUTE}`}>Back to login</Link>
    </span>
  );
};

export default BackToLogin;
